/* ===== Shopify bridge: helpers ===== */
function essImg(f){ return (window.ESS_ASSET_BASE || '') + f; }
var ESS_CFG = window.ESS_CONFIG || {};
ESS_CFG.hero = ESS_CFG.hero || {};
ESS_CFG.collections = ESS_CFG.collections || {};
ESS_CFG.community = ESS_CFG.community || {};
ESS_CFG.section = ESS_CFG.section || {};
var ESS_WA = ESS_CFG.waNumber || '919137040918';
function hasNotes(p){ return !!(p && p.notes && (p.notes.top || p.notes.heart || p.notes.base)); }
function variantById(p, vid){ var vs = p.variants || []; for (var i=0;i<vs.length;i++){ if (String(vs[i].id) === String(vid)) return vs[i]; } return null; }
function resolveVariant(p, sizeKey){
  var vs = p.variants || [];
  if (!vs.length) return null;
  var want = sizeKey === '15ml' ? '15' : sizeKey === '50ml' ? '50' : '100';
  for (var i=0;i<vs.length;i++){ if ((vs[i].title || '').indexOf(want) > -1) return vs[i]; }
  return vs[0];
}
function waProductLink(p, variantId, qty){
  var v = variantById(p, variantId);
  var line = p.title + (v && v.title ? ' (' + v.title + ')' : '') + ' x' + qty + ' — ' + formatINR(Math.round((v ? v.price : p.price)) * qty);
  return 'https://wa.me/' + ESS_WA + '?text=' + encodeURIComponent('Hi ESSENCEORA! I would like to order:\n' + line);
}
function waCartLink(){
  var items = (shopifyCart.items || []).map(function(it){ return it.product_title + (it.variant_title ? ' (' + it.variant_title + ')' : '') + ' x' + it.quantity; });
  var msg = 'Hi ESSENCEORA! I would like to order:\n' + items.join('\n');
  return 'https://wa.me/' + ESS_WA + '?text=' + encodeURIComponent(msg);
}
function checkoutUrl(){ return '/checkout' + (activePromo ? '?discount=' + encodeURIComponent(activePromo) : ''); }
function essCatForHandle(handle){
  var m = (ESS_CFG.catForHandle || {});
  return m[handle] || null;
}


/* ============ DATA & CATALOG ============ */
var COLLECTIONS = {
  her:    { key:"her",    name:"HER",    line:"HER / Fragrance Profile",    banner:essImg("img-02.webp"), blurb:"Faceted champagne and ivory glass, finished in gold — Blush Theory, Petal Haze and Rose Riot." },
  him:    { key:"him",    name:"HIM",    line:"HIM / Fragrance Profile",    banner:essImg("img-01.webp"), blurb:"Bold, architectural scents in black glass and gold — Wildroot, Afterdark and Citrus Rush." },
  unisex: { key:"unisex", name:"UNISEX", line:"UNISEX / Fragrance Profile", banner:essImg("img-03.webp"), blurb:"Minimal, clear compositions for everyone — Cloud Nine, Saffron Drift, Terra and Oudora." }
};
/* Theme-editor overrides for collection banners / blurbs */
(function(){ var c = ESS_CFG.collections; for (var k in c){ if (COLLECTIONS[k] && c[k]){ for (var f in c[k]){ if (c[k][f]) COLLECTIONS[k][f] = c[k][f]; } } } })();

var SIZE_VARIANTS = [
  { key:"15ml",  label:"15 ml · Travel Atomiser", short:"15 ml",  mult:0.38 },
  { key:"50ml",  label:"50 ml · Eau de Parfum",   short:"50 ml",  mult:0.72 },
  { key:"100ml", label:"100 ml · Eau de Parfum",  short:"100 ml", mult:1.0  }
];

/* Products are injected by Shopify (window.ESS_PRODUCTS) from the store's real catalog. */
var PRODUCTS = (window.ESS_PRODUCTS || []).map(function(p, idx){
  var n = p.num || String(idx + 1).padStart(2, '0');
  p.num = n;
  p.code = p.code || (n + ' \u00b7 ' + p.name);
  p.badge = p.badge || ('N\u00b0 ' + n);
  p.notes = (p.notes && (p.notes.top || p.notes.heart || p.notes.base)) ? p.notes : null;
  p.shortDesc = p.shortDesc || '';
  p.profile = p.profile || '';
  p.accord = p.accord || '';
  p.keyAccords = p.keyAccords || '';
  p.personality = p.personality || '';
  p.whenToWear = p.whenToWear || '';
  p.seasonal = p.seasonal || '';
  p.desc = p.desc || '';
  p.reference = p.reference || '';
  p.researchNote = p.researchNote || '';
  p.rating = parseFloat(p.rating) || 0;
  p.reviewsCount = p.reviewsCount || 0;
  p.variants = p.variants || [];
  p.price = Math.round(p.price || 0);
  return p;
});
;

var LEGACY_ID_MAP = {
  "her-1":"blush-theory", "her-2":"petal-haze", "her-3":"rose-riot",
  "him-1":"wildroot",     "him-2":"afterdark",  "him-3":"citrus-rush",
  "unisex-1":"cloud-nine","unisex-2":"saffron-drift","unisex-3":"terra"
};

var PROMO_CODES = {
  FIRST10:  { code:"FIRST10",  type:"percent", value:10, min:0,    desc:"10% off your order" },
  MUMBAI15: { code:"MUMBAI15", type:"percent", value:15, min:4000, desc:"15% off orders above ₹4,000" },
  GOLD500:  { code:"GOLD500",  type:"flat",    value:500, min:5000, desc:"₹500 off orders above ₹5,000" }
};

var DEFAULT_REVIEWS = {
  "blush-theory": [
    { name:"Ananya Deshmukh · Mumbai", rating:5, date:"18 Oct 2026", text:"Blush Theory opens with the brightest strawberry note and settles into powdery iris and creamy vanilla. Playful yet so polished." },
    { name:"Meera Nair · Bengaluru", rating:5, date:"04 Oct 2026", text:"My go-to evening and date fragrance—sweet and modern without ever feeling heavy." }
  ],
  "rose-riot": [
    { name:"Rhea Kapoor · Delhi", rating:5, date:"15 Oct 2026", text:"Pink pepper and Turkish rose with a dry amber-papyrus finish. Easily the most sophisticated rose in my collection." }
  ],
  "afterdark": [
    { name:"Aarav Mehta · Mumbai", rating:5, date:"12 Oct 2026", text:"The creamy Indian kulfi accord wrapped in neroli, warm spices, sandalwood and molten vanilla is unforgettable for evening wear." },
    { name:"Rohan Verma · Pune", rating:5, date:"28 Sep 2026", text:"Rich, sensual and opulent. Perfect for formal dinners and cooler nights." }
  ],
  "citrus-rush": [
    { name:"Siddharth Rao · Hyderabad", rating:5, date:"22 Oct 2026", text:"Calabrian bergamot and Nigerian ginger over black tea and Ambrox—so crisp and refined for daily office and travel wear." }
  ],
  "cloud-nine": [
    { name:"Kabir & Tara · Mumbai", rating:5, date:"21 Oct 2026", text:"Lemongrass and soothing rain tea with magnolia and clean woods. Airy, calm and effortlessly unisex." }
  ],
  "oudora": [
    { name:"Vikramaditya S. · Mumbai", rating:5, date:"25 Oct 2026", text:"Golden saffron, radiant jasmine grandiflorum and deep resinous oud with patchouli and Ambrox. Bold, luminous and regal." }
  ]
};

var PRICE_LABEL = "₹2,499";
function formatINR(n){ return "₹" + Math.round(Number(n||0)).toLocaleString("en-IN"); }
function byId(id){
  var realId = LEGACY_ID_MAP[id] || id;
  for (var i=0;i<PRODUCTS.length;i++) if (PRODUCTS[i].id===realId) return PRODUCTS[i];
  return null;
}
function byCat(cat){ return PRODUCTS.filter(function(p){ return p.cat===cat; }); }
function bestSellers(){ return PRODUCTS.filter(function(p){ return p.bestseller; }); }
function getSizeObj(sizeKey){
  for (var i=0;i<SIZE_VARIANTS.length;i++) if (SIZE_VARIANTS[i].key===sizeKey) return SIZE_VARIANTS[i];
  return SIZE_VARIANTS[2];
}
function variantPrice(p, sizeKey){
  if (!p) return 0;
  var v = resolveVariant(p, sizeKey || "100ml");
  return v ? Math.round(v.price) : Math.round(p.price || 0);
}

function priceOf(p, sizeKey){ return p ? formatINR(variantPrice(p, sizeKey || "100ml")) : PRICE_LABEL; }

/* Announcement marquee content */
(function(){
  var items = (ESS_CFG.marquee && ESS_CFG.marquee.length) ? ESS_CFG.marquee : ["More than a fragrance. It\u2019s a feeling.", "Complimentary Pan-India Shipping", "Use code FIRST10 for 10% Off"];
  var chunk = items.map(function(s){ return '<span>' + s + ' <b>&nbsp;\u00b7&nbsp;</b></span>'; }).join('');
  var html = ""; for (var i=0;i<3;i++) html += chunk;
  var at = document.getElementById("announceTrack"); if (at) at.innerHTML = html + html;
})();

/* Header: transparent over hero -> solid on scroll */
var siteTop = document.getElementById("siteTop");
function essSiteTop(){ if(!siteTop) siteTop = document.getElementById("siteTop"); return siteTop; }
function onScroll(){ var st = essSiteTop(); if(st) st.classList.toggle("scrolled", window.scrollY > 24); }
window.addEventListener("scroll", onScroll, { passive:true }); onScroll();

/* ============ STORAGE HELPERS ============ */
function loadJSON(key, fallback){
  try { var v = localStorage.getItem(key); return v ? JSON.parse(v) : fallback; } catch(e){ return fallback; }
}
function saveJSON(key, val){
  try { localStorage.setItem(key, JSON.stringify(val)); } catch(e){}
}

/* ============ WISHLIST ============ */
var wishlist = loadJSON("essenceora_wishlist_v1", []);
function isWished(id){ return wishlist.indexOf(id) > -1; }
function toggleWish(id){
  var idx = wishlist.indexOf(id);
  if (idx > -1){ wishlist.splice(idx, 1); showToast("Removed from wishlist"); }
  else { wishlist.push(id); showToast("Saved to wishlist"); }
  saveJSON("essenceora_wishlist_v1", wishlist);
  updateWishUI();
}
function updateWishUI(){
  var el = document.getElementById("wishCount");
  if (el){ el.style.display = wishlist.length ? "grid" : "none"; el.textContent = wishlist.length; }
  document.querySelectorAll("[data-wish]").forEach(function(btn){
    var id = btn.getAttribute("data-wish");
    btn.classList.toggle("active", isWished(id));
    btn.setAttribute("aria-pressed", isWished(id) ? "true" : "false");
  });
}

/* ============ CART & PROMO ENGINE ============ */
/* Shopify cart state (replaces localStorage cart) */
var shopifyCart = { item_count: 0, total_price: 0, items: [] };
var activePromo = "";
function refreshCart(){
  return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function(r){ return r.json(); })
    .then(function(c){ shopifyCart = c; renderCart(); return c; })
    .catch(function(){ renderCart(); });
}

function parseCartKey(key){
  var parts = key.split("::");
  return { id: parts[0], sizeKey: parts[1] || "100ml" };
}
function cartCount(){ return shopifyCart.item_count || 0; }

function cartSubtotal(){ return Math.round((shopifyCart.total_price || 0) / 100); }

function getDiscountAmount(sub){ return 0; /* promo codes are applied at Shopify checkout */ }

function addToCart(id, qty, sizeKey){
  var p = byId(id); if (!p) return;
  var v = variantById(p, sizeKey) || resolveVariant(p, sizeKey) || (p.variants || [])[0];
  if (!v){ showToast("Sorry — this fragrance is currently unavailable"); return; }
  addVariantToCart(v.id, qty || 1, p, v.title, false);
}
function addVariantToCart(variantId, qty, p, vTitle, silent){
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
  })
  .then(function(r){ if (!r.ok) throw new Error('add failed'); return r.json(); })
  .then(function(){ return refreshCart(); })
  .then(function(){ if (!silent && p) showToast("Added " + p.code + (vTitle ? " (" + vTitle + ")" : "") + " to bag"); })
  .catch(function(){ showToast("Could not add to bag — please try again"); });
}

function setQty(key, qty){
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
  })
  .then(function(r){ return r.json(); })
  .then(function(c){ shopifyCart = c; renderCart(); })
  .catch(function(){ refreshCart(); });
}

function applyPromoCode(rawCode){
  var code = (rawCode || "").trim().toUpperCase();
  if (!code){ activePromo = ""; renderCart(); return { ok:false, msg:"Enter a promo code" }; }
  activePromo = code;
  renderCart();
  return { ok:true, msg:"Code " + code + " will be applied at checkout" };
}


function renderCart(){
  var n = cartCount();
  var sub = cartSubtotal();
  var badge = document.getElementById("bagCount");
  if (badge){ badge.style.display = n ? "grid" : "none"; badge.textContent = n; }
  var dc = document.getElementById("drawerCount");
  if (dc) dc.textContent = n ? "(" + n + ")" : "";

  var threshold = 3500;
  var pct = Math.min(100, Math.round((sub / threshold) * 100));
  var meterTxt = document.getElementById("shipMeterText");
  var meterFill = document.getElementById("shipMeterFill");
  if (meterTxt && meterFill){
    meterFill.style.width = pct + "%";
    meterTxt.innerHTML = sub >= threshold
      ? "Unlocked: <strong>Complimentary Express Air Delivery + 5 ml Discovery Vial</strong>"
      : "Add <strong>" + formatINR(threshold - sub) + "</strong> more for Complimentary Express Delivery &amp; a Free 5 ml Vial";
  }

  var box = document.getElementById("drawerItems");
  var foot = document.getElementById("drawerFoot");
  if (!box || !foot) return;
  if (!n){
    box.innerHTML = '<div class="drawer-empty"><div class="big">Your bag is empty</div><p>Discover the collection and add a fragrance that feels like you.</p></div>';
    foot.style.display = "none"; return;
  }
  foot.style.display = "grid";
  document.getElementById("drawerSubtotal").textContent = formatINR(sub);
  var discRow = document.getElementById("drawerDiscountRow");
  if (activePromo){
    discRow.style.display = "flex";
    document.getElementById("drawerDiscountLabel").textContent = "Promo (" + activePromo + ")";
    document.getElementById("drawerDiscountVal").textContent = "at checkout";
  } else {
    discRow.style.display = "none";
  }
  document.getElementById("drawerTotal").textContent = formatINR(sub);
  var promoIn = document.getElementById("drawerPromoInput");
  if (promoIn && activePromo) promoIn.value = activePromo;

  var html = "";
  (shopifyCart.items || []).forEach(function(it){
    var unitP = Math.round(it.price / 100);
    html += '<div class="ci"><a href="#/product/' + it.handle + '"><img src="' + it.image + '" alt="' + it.product_title.replace(/"/g, '') + '"></a>'
      + '<div class="ci-info"><h4>' + it.product_title.toUpperCase() + '</h4><div class="cat">' + (it.variant_title || '') + '</div>'
      + '<div class="cat" style="color:var(--gold-deep);font-weight:700;margin-top:3px">' + formatINR(unitP) + ' each &middot; ' + formatINR(unitP * it.quantity) + '</div>'
      + '<div class="ci-row"><span class="qty"><button data-dec="' + it.key + '" aria-label="Decrease quantity">\u2212</button><output>' + it.quantity + '</output><button data-inc="' + it.key + '" aria-label="Increase quantity">+</button></span>'
      + '<button class="remove" data-remove="' + it.key + '">Remove</button></div></div></div>';
  });
  box.innerHTML = html;
  box.querySelectorAll("[data-inc]").forEach(function(b){ b.addEventListener("click", function(){ var k = b.getAttribute("data-inc"); var it = (shopifyCart.items || []).filter(function(x){ return x.key === k; })[0]; if (it) setQty(k, it.quantity + 1); }); });
  box.querySelectorAll("[data-dec]").forEach(function(b){ b.addEventListener("click", function(){ var k = b.getAttribute("data-dec"); var it = (shopifyCart.items || []).filter(function(x){ return x.key === k; })[0]; if (it) setQty(k, it.quantity - 1); }); });
  box.querySelectorAll("[data-remove]").forEach(function(b){ b.addEventListener("click", function(){ setQty(b.getAttribute("data-remove"), 0); }); });
  box.querySelectorAll("a").forEach(function(a){ a.addEventListener("click", closeCart); });
  var waLink = document.getElementById("drawerWaLink");
  if (waLink) waLink.href = waCartLink();
}

function openCart(){
  var d = document.getElementById("cartDrawer");
  d.classList.add("show");
  requestAnimationFrame(function(){ requestAnimationFrame(function(){ d.classList.add("open"); }); });
  document.getElementById("overlay").classList.add("show");
}
function closeCart(){
  var d = document.getElementById("cartDrawer");
  if (!d.classList.contains("show")){ document.getElementById("overlay").classList.remove("show"); return; }
  d.classList.remove("open");
  document.getElementById("overlay").classList.remove("show");
  setTimeout(function(){ if (!d.classList.contains("open")) d.classList.remove("show"); }, 420);
}

var toastTimer;
function showToast(msg){
  var t = document.getElementById("toast"); t.textContent = msg; t.classList.add("show");
  clearTimeout(toastTimer); toastTimer = setTimeout(function(){ t.classList.remove("show"); }, 2400);
}

/* ============ TEMPLATES ============ */
function cardHTML(p){
  var wished = isWished(p.id);
  return '<div class="card"><div class="card-media">'
    + '<a href="#/product/'+p.id+'" aria-label="View '+p.name+'"><img class="main" src="'+p.img+'" alt="ESSENCEORA '+p.name+' perfume bottle">'
    + '<img class="alt" src="'+p.alt+'" alt="" aria-hidden="true"></a>'
    + '<span class="badge">'+p.badge+'</span>'
    + '<button class="wish-btn'+(wished?' active':'')+'" data-wish="'+p.id+'" aria-label="Save '+p.name+' to wishlist" aria-pressed="'+(wished?'true':'false')+'"><svg viewBox="0 0 24 24"><path d="M12 20.5s-7-4.6-9.2-8.6A5.4 5.4 0 0 1 12 6a5.4 5.4 0 0 1 9.2 5.9c-2.2 4-9.2 8.6-9.2 8.6Z"/></svg></button>'
    + '<button class="quick-add" data-add="'+p.id+'">Add to Bag · '+priceOf(p, "100ml")+'</button></div>'
    + '<div class="card-info"><a href="#/product/'+p.id+'"><h4>'+p.num+' · '+p.name+'</h4></a><div class="cat">'+COLLECTIONS[p.cat].name+' · '+p.profile+'</div>'
    + '<p class="short-desc">'+p.shortDesc+'</p>'
    + '<div class="card-meta-row"><div class="price">'+priceOf(p, "100ml")+' <span style="color:var(--muted);font-weight:400;font-size:11px">/ 100 ml</span></div>'
    + '' + (p.rating > 0 ? '<div class="rating-mini">★ '+p.rating.toFixed(1)+' ('+p.reviewsCount+')</div>' : '') + '</div></div></div>';
}
function gridHTML(list){ return '<div class="grid">' + list.map(cardHTML).join("") + '</div>'; }
function bindQuickAdd(scope){
  scope.querySelectorAll("[data-add]").forEach(function(b){
    b.addEventListener("click", function(e){ e.preventDefault(); e.stopPropagation(); addToCart(b.getAttribute("data-add"), 1, "100ml"); openCart(); });
  });
  scope.querySelectorAll("[data-wish]").forEach(function(b){
    b.addEventListener("click", function(e){ e.preventDefault(); e.stopPropagation(); toggleWish(b.getAttribute("data-wish")); });
  });
}
var carouselSeq = 0;
function carouselHTML(list, titleHTML, subText){
  carouselSeq++;
  var id = "car" + carouselSeq;
  return '<div class="carousel-block"><div class="carousel-head"><div><h3>'+titleHTML+'</h3>'
    + (subText ? '<div class="ch-sub">'+subText+'</div>' : '') + '</div>'
    + '<div class="arrows"><button class="arrow-btn" data-car-prev="'+id+'" aria-label="Scroll products back"><svg viewBox="0 0 24 24"><path d="M15 5l-7 7 7 7"/></svg></button>'
    + '<button class="arrow-btn" data-car-next="'+id+'" aria-label="Scroll products forward"><svg viewBox="0 0 24 24"><path d="M9 5l7 7-7 7"/></svg></button></div></div>'
    + '<div class="carousel" id="'+id+'">' + list.map(cardHTML).join("") + '</div></div>';
}
function smoothHorizontalScroll(el, delta, duration){
  var start = el.scrollLeft;
  var maxScroll = el.scrollWidth - el.clientWidth;
  var target = Math.max(0, Math.min(maxScroll, start + delta));
  var change = target - start;
  if (Math.abs(change) < 2) return;
  var startTime = performance.now();
  var dur = duration || 560;
  var prevSnap = el.style.scrollSnapType;
  el.style.scrollSnapType = "none";
  function step(now){
    var t = Math.min(1, (now - startTime) / dur);
    var ease = 1 - Math.pow(1 - t, 3.5);
    el.scrollLeft = start + change * ease;
    if (t < 1) requestAnimationFrame(step);
    else el.style.scrollSnapType = prevSnap || "";
  }
  requestAnimationFrame(step);
}

function bindCarousels(scope){
  scope.querySelectorAll("[data-car-prev],[data-car-next]").forEach(function(b){
    b.addEventListener("click", function(){
      var id = b.getAttribute("data-car-prev") || b.getAttribute("data-car-next");
      var track = document.getElementById(id); if (!track) return;
      var step = Math.min(track.clientWidth * 0.82, 420);
      smoothHorizontalScroll(track, b.hasAttribute("data-car-prev") ? -step : step, 580);
    });
  });
  scope.querySelectorAll(".carousel").forEach(function(track){
    var isDown = false, startX = 0, scrollStart = 0, moved = false;
    track.addEventListener("mousedown", function(e){
      if (e.button !== 0) return;
      isDown = true; moved = false;
      startX = e.pageX - track.offsetLeft;
      scrollStart = track.scrollLeft;
      track.classList.add("dragging");
    });
    window.addEventListener("mouseup", function(){
      if (!isDown) return;
      isDown = false;
      track.classList.remove("dragging");
    });
    track.addEventListener("mousemove", function(e){
      if (!isDown) return;
      var x = e.pageX - track.offsetLeft;
      var walk = (x - startX) * 1.25;
      if (Math.abs(walk) > 6){ moved = true; e.preventDefault(); track.scrollLeft = scrollStart - walk; }
    });
    track.addEventListener("click", function(e){
      if (moved){ e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  });
}
function collectionSection(cat){
  var c = COLLECTIONS[cat];
  return '<a class="coll-banner" href="#/collection/'+cat+'" aria-label="Shop the '+c.name+' collection"><img src="'+c.banner+'" alt="ESSENCEORA '+c.name+' fragrance collection">'
    + '<div class="cb-copy"><span class="label">The Fragrance Collection</span><h2>'+c.name+'</h2><span class="btn btn-white">Shop '+c.name+'</span></div></a>'
    + carouselHTML(byCat(cat), c.name+' <span>— Fragrance Profiles</span>', c.blurb);
}

function catalogueDirectoryHTML(){
  var items = PRODUCTS.map(function(p){
    return '<a class="cat-index-item" href="#/product/'+p.id+'"><div><strong>'+p.num+' '+p.name+'</strong><div style="font-size:12px;color:var(--muted);margin-top:3px;letter-spacing:-.02em">'+p.profile+'</div></div><span>'+COLLECTIONS[p.cat].name+' →</span></a>';
  }).join("");
  return '<section class="cat-index-sec"><div class="carousel-head" style="padding:0"><div><h3>The Fragrance <span>Collection (01–' + String(PRODUCTS.length).padStart(2,'0') + ')</span></h3><div class="ch-sub">Product Descriptions • Note Pyramids • Scent Profiles</div></div><a class="btn btn-outline" href="#/about" style="padding:11px 18px;font-size:11px">How to Read This Catalogue</a></div>'
    + '<div class="cat-index-grid">'+items+'</div>'
    + '<div class="guide-grid">'
    + '<div class="guide-card"><h4>Top, Heart &amp; Base Notes</h4><p>Top notes describe the first impression. Heart notes describe the central character as the opening settles. Base notes describe the deeper notes that remain during the dry-down. A note can be a natural material, a synthetic aroma material, or an accord constructed from several materials.</p></div>'
    + '<div class="guide-card"><h4>Scent Ingredients &amp; Accords</h4><p>Each fragrance profile details the key scent impressions and olfactory accords that shape the composition—from juicy fruit and luminous florals to creamy kulfi, tea, earthy vetiver, and resinous oud.</p></div>'
    + '<div class="guide-card"><h4>Performance &amp; Wear</h4><p>Longevity and projection depend on the exact oil, concentration, base, maturation, spray output, skin chemistry, climate and application. Each profile includes tailored recommendations for When to Wear and Seasonal Character.</p></div>'
    + '</div></section>';
}

function homePage(){
  return '<section class="hero">'
    + '<video class="bg" id="heroVideo" src="'+ESS_CFG.hero.video+'" poster="'+ESS_CFG.hero.poster+'" autoplay muted loop playsinline preload="auto" aria-hidden="true"><source src="'+ESS_CFG.hero.video+'" type="video/mp4"></video>'
    + '<div class="hero-copy"><div class="hero-eyebrow">'+ESS_CFG.hero.eyebrow+'</div>'
    + '<h1>'+ESS_CFG.hero.headingA+' <span class="gold">'+ESS_CFG.hero.headingB+'</span></h1>'
    + '<p class="hero-sub">'+ESS_CFG.hero.sub+'</p>'
    + '<button class="btn btn-white" id="heroShopBtn">'+ESS_CFG.hero.btn+'</button></div></section>'
    + '<div id="collectionsStart"></div>'
    + (ESS_CFG.section.showBestsellers === false ? '' : carouselHTML(bestSellers(), 'Best <span>Sellers</span>', 'Signature favourites across HER · HIM · UNISEX'))
    + collectionSection("her") + collectionSection("him") + collectionSection("unisex")
    + (ESS_CFG.section.showCatalogue === false ? '' : catalogueDirectoryHTML())
    + '<section class="community"><span class="label">'+ESS_CFG.community.label+'</span>'
    + '<h2>'+ESS_CFG.community.heading+'</h2>'
    + '<p>'+ESS_CFG.community.text+'</p>'
    + '<a class="btn btn-black" href="#/shop">'+ESS_CFG.community.btn+'</a></section>';
}

/* Shop state for filters & sorting */
var shopState = { cat:"all", accord:"all", sort:"featured" };
function getFilteredProducts(lockCat){
  var catFilter = lockCat || shopState.cat;
  var list = PRODUCTS.filter(function(p){
    if (catFilter !== "all" && p.cat !== catFilter) return false;
    if (shopState.accord !== "all" && p.accord !== shopState.accord) return false;
    return true;
  });
  if (shopState.sort === "price-asc") list.sort(function(a,b){ return a.price - b.price; });
  else if (shopState.sort === "price-desc") list.sort(function(a,b){ return b.price - a.price; });
  else if (shopState.sort === "rating") list.sort(function(a,b){ return b.rating - a.rating; });
  else if (shopState.sort === "name") list.sort(function(a,b){ return a.name.localeCompare(b.name); });
  return list;
}

function shopToolbarHTML(lockCat){
  var accords = ["all", "Fruity & Gourmand", "Floral & Musky", "Floral & Amber", "Fresh & Woody", "Amber & Gourmand", "Citrus & Amber", "Fresh & Tea", "Fresh & Musky", "Woody & Oud"];
  var html = '<div class="shop-toolbar"><div class="filter-group">';
  if (!lockCat){
    ["all","her","him","unisex"].forEach(function(c){
      var label = c === "all" ? "All " + PRODUCTS.length + " Scents" : COLLECTIONS[c].name;
      html += '<button class="filter-pill'+(shopState.cat===c?' active':'')+'" data-filter-cat="'+c+'">'+label+'</button>';
    });
  }
  accords.forEach(function(ac){
    var label = ac === "all" ? "All Profiles" : ac;
    html += '<button class="filter-pill'+(shopState.accord===ac?' active':'')+'" data-filter-accord="'+ac+'">'+label+'</button>';
  });
  html += '</div><div class="sort-wrap"><label class="label" for="sortSelect" style="font-size:10px">Sort By</label>'
    + '<select id="sortSelect" class="sort-select">'
    + '<option value="featured"'+(shopState.sort==="featured"?' selected':'')+'>Catalogue Order (01–10)</option>'
    + '<option value="rating"'+(shopState.sort==="rating"?' selected':'')+'>Highest Rated</option>'
    + '<option value="price-asc"'+(shopState.sort==="price-asc"?' selected':'')+'>Price: Low to High</option>'
    + '<option value="price-desc"'+(shopState.sort==="price-desc"?' selected':'')+'>Price: High to Low</option>'
    + '<option value="name"'+(shopState.sort==="name"?' selected':'')+'>Name: A–Z</option>'
    + '</select></div></div>';
  return html;
}

function bindShopToolbar(lockCat){
  var box = document.getElementById("shopGridWrap");
  if (!box) return;
  app.querySelectorAll("[data-filter-cat]").forEach(function(b){
    b.addEventListener("click", function(){
      shopState.cat = b.getAttribute("data-filter-cat");
      render();
    });
  });
  app.querySelectorAll("[data-filter-accord]").forEach(function(b){
    b.addEventListener("click", function(){
      shopState.accord = b.getAttribute("data-filter-accord");
      render();
    });
  });
  var sel = document.getElementById("sortSelect");
  if (sel){
    sel.addEventListener("change", function(){
      shopState.sort = sel.value;
      render();
    });
  }
}

function shopPage(){
  var list = getFilteredProducts(null);
  return '<div class="page-banner"><img src="'+essImg("img-22.webp")+'" alt="The complete ESSENCEORA fragrance collection"><div class="pb-copy"><span class="label">ESSENCEORA · The Fragrance Collection</span><h1>Shop All '+PRODUCTS.length+' Scents</h1><p>'+PRODUCTS.map(function(p){ return p.num+' '+p.name; }).join(' · ')+'</p><p style="display:none">01 Blush Theory · 02 Petal Haze · 03 Rose Riot · 04 Wildroot · 05 Afterdark · 06 Citrus Rush · 07 Cloud Nine · 08 Saffron Drift · 09 Terra · 10 Oudora</p></div></div>'
    + '<section class="section">' + shopToolbarHTML(null)
    + '<div id="shopGridWrap">' + (list.length ? gridHTML(list) : '<p style="color:var(--muted);padding:32px 0">No fragrances match the selected filter. <button class="continue-link" id="resetFilterBtn">Reset filters</button></p>') + '</div></section>';
}

function collectionPage(cat){
  var c = COLLECTIONS[cat];
  var list = getFilteredProducts(cat);
  return '<div class="page-banner"><img src="'+c.banner+'" alt="ESSENCEORA '+c.name+' fragrance collection"><div class="pb-copy"><span class="label">'+c.line+'</span><h1>'+c.name+'</h1><p>'+c.blurb+'</p></div></div>'
    + '<section class="section">' + shopToolbarHTML(cat)
    + '<div id="shopGridWrap">' + gridHTML(list) + '</div></section>';
}

function getReviewsFor(id){
  var stored = loadJSON("essenceora_reviews_v1", {});
  var custom = stored[id] || [];
  var base = DEFAULT_REVIEWS[id] || [
    { name:"Vikram S. · Mumbai", rating:5, date:"14 Oct 2026", text:"Exquisite composition and note progression. The bottle presentation and dry-down feel truly world-class." }
  ];
  return custom.concat(base);
}

function productPage(id){
  var p = byId(id); if (!p) return shopPage();
  var c = COLLECTIONS[p.cat];
  var others = PRODUCTS.filter(function(x){ return x.id!==p.id; });
  var wished = isWished(p.id);
  var revs = getReviewsFor(p.id);
  var sizeBtns = (p.variants || []).map(function(v, vi){
    var active = vi === 0 ? " active" : "";
    return '<button type="button" class="size-opt'+active+'" data-size-opt="'+v.id+'">'
      + '<strong>'+v.title+'</strong><small>'+formatINR(Math.round(v.price))+'</small></button>';
  }).join("");
  if (!sizeBtns) sizeBtns = '<span style="font-size:13px;color:var(--muted)">One size</span>';

  var revsHTML = revs.map(function(r){
    var stars = ""; for (var i=0;i<5;i++) stars += (i < r.rating ? "★" : "☆");
    return '<div class="review-item"><div class="review-item-head"><div><strong>'+r.name+'</strong> <span class="verified-tag">· Verified Buyer</span></div><span class="review-stars">'+stars+'</span></div>'
      + '<p style="font-size:14px;color:var(--ink)">'+r.text+'</p><small style="color:var(--muted);font-size:11.5px;display:block;margin-top:6px">'+r.date+'</small></div>';
  }).join("");

  return '<div class="plain-top"><div class="product-wrap"><div><div class="gallery-main"><img id="pdMain" src="'+p.img+'" alt="ESSENCEORA '+p.name+' perfume bottle"></div>'
    + '<div class="thumbs"><button class="active" data-thumb="'+p.img+'" aria-label="View one"><img src="'+p.img+'" alt=""></button>'
    + '<button data-thumb="'+p.alt+'" aria-label="View two"><img src="'+p.alt+'" alt=""></button></div></div>'
    + '<div class="pd"><div class="crumb"><a href="#/">Home</a> / <a href="#/collection/'+p.cat+'">'+c.name+'</a> / '+p.num+' '+p.name+'</div>'
    + '<span class="pd-badge">N° '+p.num+' · '+c.line+'</span>'
    + '<h1>'+p.name+'</h1><div class="pd-cat">'+p.profile+' · ★ '+p.rating.toFixed(1)+' ('+revs.length+' reviews)</div>'
    + '<div class="pd-price" id="pdPriceDisplay">'+priceOf(p, "100ml")+' <span style="font-size:13px;color:var(--muted);font-family:var(--sans);font-weight:400">Inclusive of all taxes</span></div>'
    + '<p class="pd-desc" style="font-weight:600;margin-bottom:8px">'+p.shortDesc+'</p>'
    + '<p class="pd-desc">'+p.desc+'</p>'
    + (hasNotes(p) ? '<div class="notes-pyramid" aria-label="The Scent Journey">'
    + '<div style="font-size:11px;letter-spacing:.18em;text-transform:uppercase;color:var(--gold-deep);font-weight:700;margin-bottom:2px">The Scent Journey</div>'
    + '<div class="note-row"><strong>Top Notes</strong><span>'+p.notes.top+'</span></div>'
    + '<div class="note-row"><strong>Heart Notes</strong><span>'+p.notes.heart+'</span></div>'
    + '<div class="note-row"><strong>Base Notes</strong><span>'+p.notes.base+'</span></div>'
    + '<div class="note-row"><strong>Key Accords</strong><span>'+p.keyAccords+'</span></div>'
    + '</div>' : '')
    + '<div class="size-block"><span class="label">Select Bottle Size</span><div class="size-options" id="pdSizeOptions">'+sizeBtns+'</div>'
    + '<div class="stock-pill">In Stock · Dispatches within 24 hours from Mumbai</div></div>'
    + '<div class="qty-row"><span class="qty"><button id="qDec" aria-label="Decrease quantity">−</button><output id="qOut">1</output><button id="qInc" aria-label="Increase quantity">+</button></span><span class="qty-label">Quantity</span></div>'
    + '<div class="stack"><button class="btn btn-black" id="pdAdd">Add to Bag</button>'
    + '<button class="btn btn-outline" id="pdBuyNow">Buy It Now · Instant Checkout</button>'
    + '<a class="btn btn-outline" id="pdWaBtn" target="_blank" rel="noopener" href="#">Buy on WhatsApp</a>'
    + '<button class="btn btn-outline" id="pdWishBtn" data-wish="'+p.id+'" style="border-color:var(--line)">'+(wished ? '♥ Saved in Wishlist' : '♡ Save to Wishlist')+'</button></div>'
    + '<div class="accordion"><div class="acc-item open"><button class="acc-head">When to Wear &amp; Seasonal Character <span>+</span></button>'
    + '<div class="acc-body"><strong>Personality:</strong> '+p.personality+'<br><strong>When to Wear:</strong> '+p.whenToWear+'<br><strong>Seasonal Character:</strong> '+p.seasonal+'</div></div>'
    + '<div class="acc-item"><button class="acc-head">Research, Formulation &amp; Performance Note <span>+</span></button>'
    + '<div class="acc-body"><strong>Olfactory Reference:</strong> '+p.reference+'. '+p.researchNote+'<br><br><strong>Performance:</strong> Longevity and projection depend on the exact oil, concentration, alcohol/base, maturation, spray output, skin, climate and application.</div></div></div>'
    + '</div></div>'
    + '<section class="details-spec"><h2>Details</h2><dl class="details-rows">'
    + '<div class="details-row"><dt>Description</dt><dd>'+p.desc+'</dd></div>'
    + '<div class="details-row"><dt>Short Description</dt><dd>'+p.shortDesc+'</dd></div>'
    + '<div class="details-row"><dt>Scent Profile</dt><dd>'+p.profile+' ('+c.line+')</dd></div>'
    + (hasNotes(p) ? '<div class="details-row"><dt>The Scent Journey</dt><dd>Top Notes: '+p.notes.top+' · Heart Notes: '+p.notes.heart+' · Base Notes: '+p.notes.base+'</dd></div>' : '')
    + (p.keyAccords ? '<div class="details-row"><dt>Key Scent Accords</dt><dd>'+p.keyAccords+'</dd></div>' : '')
    + (p.personality ? '<div class="details-row"><dt>Personality</dt><dd>'+p.personality+'</dd></div>' : '')
    + (p.whenToWear ? '<div class="details-row"><dt>When to Wear</dt><dd>'+p.whenToWear+'</dd></div>' : '')
    + (p.seasonal ? '<div class="details-row"><dt>Seasonal Character</dt><dd>'+p.seasonal+'</dd></div>' : '')
    + ((p.reference || p.researchNote) ? '<div class="details-row"><dt>Formulation Note</dt><dd>Internal reference: '+p.reference+'. '+p.researchNote+'</dd></div>' : '')
    + '</dl></section>'
    + ((p.rating > 0 || (typeof revs !== 'undefined' && revs.length)) ? '<section class="reviews-block"><div class="carousel-head" style="padding:0;margin-bottom:10px"><div><h3>Client <span>Reviews</span></h3><div class="ch-sub">★ '+p.rating.toFixed(1)+' Average Rating · '+revs.length+' Verified Reviews</div></div></div>'
    + '<div class="reviews-grid"><div>'+revsHTML+'</div>'
    + '<form class="co-panel" id="reviewForm"><h2 style="font-size:18px;margin-bottom:12px">Write a Review</h2>'
    + '<div class="form-grid"><div class="form-field"><label for="revName">Your Name &amp; City</label><input id="revName" required placeholder="e.g. Siddharth · Mumbai"></div>'
    + '<div class="form-field"><label for="revRating">Rating</label><select id="revRating"><option value="5">★★★★★ (5/5)</option><option value="4">★★★★☆ (4/5)</option><option value="3">★★★☆☆ (3/5)</option></select></div>'
    + '<div class="form-field full"><label for="revText">Your Experience</label><textarea id="revText" rows="3" required placeholder="Share how the top, heart, and base notes wear on your skin..."></textarea></div></div>'
    + '<button type="submit" class="btn btn-black" style="margin-top:14px">Submit Review</button></form></div></section>' : '')
    + '<div class="like-block">' + carouselHTML(others, 'You may <span>also like</span>', 'Explore the 10 ESSENCEORA fragrances') + '</div></div>';
}

function wishlistPage(){
  var items = wishlist.map(byId).filter(Boolean);
  return '<div class="plain-top"><div class="ecom-wrap"><div class="ecom-head"><div><span class="label" style="color:var(--gold-deep)">Your Personal Edit</span><h1>Saved Wishlist ('+items.length+')</h1></div>'
    + (items.length ? '<button class="btn btn-black" id="wishMoveAllBtn">Add All to Bag</button>' : '') + '</div>'
    + (items.length ? gridHTML(items) : '<div class="order-card" style="text-align:center;padding:56px 20px"><h2 style="font-family:var(--cond);font-size:28px;text-transform:uppercase">Your wishlist is empty</h2><p style="color:var(--muted);margin:10px auto 24px;max-width:44ch">Tap the heart icon on any fragrance to save your favourite compositions for later.</p><a class="btn btn-black" href="#/shop">Explore Fragrances</a></div>')
    + '</div></div>';
}

/* checkoutPage removed in Shopify theme: real Shopify checkout / customer accounts are used instead. */


/* renderPaymentSubbox removed in Shopify theme: real Shopify checkout / customer accounts are used instead. */


/* ordersListPage removed in Shopify theme: real Shopify checkout / customer accounts are used instead. */


function aboutPage(){
  var contentsRows = PRODUCTS.map(function(p){
    return '<div class="details-row"><dt><a href="#/product/'+p.id+'" style="text-decoration:underline;text-underline-offset:4px">'+p.num+' '+p.name+' — '+COLLECTIONS[p.cat].name+'</a></dt><dd><strong>'+p.profile+'</strong> · '+p.shortDesc+'<br><span style="color:var(--muted);font-size:13.5px">Top: '+p.notes.top+' · Heart: '+p.notes.heart+' · Base: '+p.notes.base+'</span></dd></div>';
  }).join("");

  return '<div class="plain-top"><div class="content" style="max-width:1120px"><span class="label">ESSENCEORA · The Fragrance Collection</span>'
    + '<h1>Product Storytelling &amp; Fragrance-Note Guide</h1>'
    + '<p>A complete product storytelling and fragrance-note guide for the ten signature ESSENCEORA scents — crafted in champagne, ivory, black and gold.</p>'
    + '<div class="palette">'
    + '<div class="swatch"><i style="background:#E9D8B6"></i><span>Champagne</span></div>'
    + '<div class="swatch"><i style="background:#FAF7F0"></i><span>Ivory</span></div>'
    + '<div class="swatch"><i style="background:#0A0A0A"></i><span>Black</span></div>'
    + '<div class="swatch"><i style="background:#C6A15B"></i><span>Gold</span></div></div>'
    + '<section class="details-spec" style="text-align:left;margin-top:42px;padding-left:0;padding-right:0"><h2>Contents (01–10)</h2><dl class="details-rows" style="max-width:100%">'
    + contentsRows
    + '</dl></section>'
    + '<section class="details-spec" style="text-align:left;margin-top:20px;padding-left:0;padding-right:0"><h2>How to Read This Catalogue</h2><dl class="details-rows" style="max-width:100%">'
    + '<div class="details-row"><dt>Note Pyramid</dt><dd>Top notes describe the first impression. Heart notes describe the central character as the opening settles. Base notes describe the deeper notes that remain during the dry-down. A note can be a natural material, a synthetic aroma material, or an accord constructed from several materials.</dd></div>'
    + '<div class="details-row"><dt>Ingredients &amp; Accords</dt><dd>The ingredient and accord list in each profile describes the scent materials and olfactory accords associated with the fragrance profile. Published fragrance notes are an olfactory guide and are distinct from a finished-product INCI/allergen declaration.</dd></div>'
    + '<div class="details-row"><dt>Performance</dt><dd>Longevity and projection depend on the exact oil, concentration, alcohol/base, maturation, spray output, skin chemistry, climate and application.</dd></div>'
    + '<div class="details-row"><dt>Quality &amp; Standards</dt><dd>Every ESSENCEORA batch undergoes olfactory evaluation, IFRA conformity verification, allergen documentation, and stability and packaging compatibility checks prior to release from our Mumbai studio.</dd></div>'
    + '</dl></section>'
    + '<p style="margin-top:34px"><a class="btn btn-black" href="#/shop">Shop All 10 Fragrances</a></p></div></div>';
}

function contactPage(){
  return '<div class="plain-top"><div class="content" style="max-width:1120px"><span class="label">We would love to hear from you</span>'
    + '<h1>Contact ESSENCEORA</h1>'
    + '<p>Whether you would like a personal fragrance recommendation, bespoke gifting assistance, or an update on your online order — reach our Mumbai studio directly by phone, email, or the concierge form below. Studio hours: Monday to Sunday, 10:00 AM – 8:00 PM IST.</p>'
    + '<div class="contact-cards">'
    + '<div class="contact-card"><h3>Studio Telephone</h3><a href="tel:+919137040918">+91 91370 40918</a><small>Direct client care &amp; fragrance consultations (10 AM – 8 PM IST)</small></div>'
    + '<div class="contact-card"><h3>Email &amp; Enquiries</h3><a href="mailto:kadlagshubhangi658@gmail.com">kadlagshubhangi658@gmail.com</a><small>For order support, corporate gifting, and press enquiries</small></div>'
    + '<div class="contact-card"><h3>Mumbai Studio Address</h3><p>Flat no. 308, B Wing, Maryland Apartment, D.K. Sandu Marg, behind Lion&rsquo;s Charitable Hospital, opposite Society Store, Chembur, Mumbai, 400071</p><small>Same-day dispatch across Mumbai · Insured Pan-India delivery</small></div>'
    + '</div>'
    + '<form id="contactForm" class="co-panel" style="max-width:760px;margin:34px auto 0;text-align:left">'
    + '<h2 style="margin-bottom:14px">Send a Message to the Studio</h2>'
    + '<div class="form-grid">'
    + '<div class="form-field"><label for="ctName">Your Name *</label><input id="ctName" required placeholder="Full Name"></div>'
    + '<div class="form-field"><label for="ctEmail">Email Address *</label><input type="email" id="ctEmail" required placeholder="you@example.com"></div>'
    + '<div class="form-field full"><label for="ctSubject">Subject *</label><select id="ctSubject"><option>Fragrance Recommendation / Scent Advice</option><option>Order Status / Shipping Enquiry</option><option>Luxury &amp; Corporate Gifting</option><option>General Enquiry</option></select></div>'
    + '<div class="form-field full"><label for="ctMsg">Message *</label><textarea id="ctMsg" rows="4" required placeholder="Tell us how we can assist you..."></textarea></div>'
    + '</div>'
    + '<button type="submit" class="btn btn-black" style="margin-top:16px">Send Message</button>'
    + '</form></div></div>';
}

/* ============ ROUTER ============ */
var app = document.getElementById("app");
function accountPage(){
  return '<div class="plain-top"><div class="ecom-wrap"><div class="order-card" style="text-align:center;padding:64px 20px">'
    + '<span class="label" style="color:var(--gold-deep)">Client Account</span>'
    + '<h1 style="font-family:var(--cond);font-size:42px;text-transform:uppercase;margin-top:8px">Track Your Orders</h1>'
    + '<p style="color:var(--muted);margin:12px auto 26px;max-width:46ch">Orders placed through our secure checkout live in your account — view status, invoices and reorder in one place.</p>'
    + '<a class="btn btn-black" href="/account">Go to My Account</a></div></div></div>';
}
function notFoundHTML(){
  return '<div class="plain-top"><div class="ecom-wrap"><div class="order-card" style="text-align:center;padding:64px 20px">'
    + '<span class="label" style="color:var(--gold-deep)">ESSENCEORA</span>'
    + '<h1 style="font-family:var(--cond);font-size:42px;text-transform:uppercase;margin-top:8px">Page Not Found</h1>'
    + '<p style="color:var(--muted);margin:12px auto 26px;max-width:46ch">The page you are looking for has moved or no longer exists.</p>'
    + '<a class="btn btn-black" href="#/">Back to Home</a></div></div></div>';
}
function pageBootHTML(handle){
  var b = window.ESS_BOOT || {};
  if (handle === "about") return aboutPage();
  if (handle === "contact") return contactPage();
  var title = b.pageTitle || "ESSENCEORA";
  var phtml = b.pageHtml || "";
  return '<div class="plain-top"><div class="ecom-wrap"><div class="order-card">'
    + '<span class="label" style="color:var(--gold-deep)">ESSENCEORA</span>'
    + '<h1 style="font-family:var(--cond);font-size:42px;text-transform:uppercase;margin:8px 0 18px">' + title + '</h1>'
    + '<div class="page-rich">' + phtml + '</div></div></div></div>';
}
function render(){
  var hash = location.hash.replace(/^#\/?/, "");
  var parts = hash.split("/").filter(Boolean);
  var boot = window.__essBootDone ? null : window.ESS_BOOT;
  if (!parts.length && boot){
    window.__essBootDone = true;
    if (boot.route === "product" && boot.handle) parts = ["product", boot.handle];
    else if (boot.route === "collection" && boot.handle){ var c0 = essCatForHandle(boot.handle); parts = c0 ? ["collection", c0] : ["shop"]; }
    else if (boot.route === "page" && boot.handle) parts = ["page", boot.handle];
    else if (boot.route === "404") parts = ["__404"];
    else if (boot.route === "cart"){ parts = []; window.__essOpenCart = true; }
    else if (boot.route === "search"){ parts = []; window.__essSearchTerms = boot.handle || ""; }
  }
  var html, navKey = "", plain = false;
  if (parts.length===0){ html = homePage(); }
  else if (parts[0]==="shop"){ html = shopPage(); navKey="shop"; }
  else if (parts[0]==="collection" && COLLECTIONS[parts[1]]){ html = collectionPage(parts[1]); navKey=parts[1]; }
  else if (parts[0]==="product" && byId(parts[1])){ html = productPage(parts[1]); navKey = byId(parts[1]).cat; plain = true; }
  else if (parts[0]==="wishlist"){ html = wishlistPage(); plain = true; }
  else if (parts[0]==="checkout"){ location.replace(checkoutUrl()); return; }
  else if (parts[0]==="orders" || parts[0]==="order"){ html = accountPage(); navKey="orders"; plain = true; }
  else if (parts[0]==="page" && parts[1]){ html = pageBootHTML(parts[1]); plain = true; }
  else if (parts[0]==="__404"){ html = notFoundHTML(); plain = true; }
  else if (parts[0]==="about"){ html = aboutPage(); navKey="about"; plain = true; }
  else if (parts[0]==="contact"){ html = contactPage(); navKey="contact"; plain = true; }
  else { html = homePage(); }

  document.body.classList.toggle("force-solid", plain);
  app.innerHTML = html;
  bindQuickAdd(app);
  bindCarousels(app);
  updateWishUI();
  document.querySelectorAll("#navLinks a").forEach(function(a){ a.classList.toggle("active", a.getAttribute("data-nav")===navKey); });
  document.getElementById("mobileMenu").classList.remove("open");
  closeCart();
  smoothScrollResetTop();
  initScrollReveal(app);

  if (window.__essOpenCart){ window.__essOpenCart = false; refreshCart().then(function(){ openCart(); }); }
  if (typeof window.__essSearchTerms !== "undefined"){
    var __st = window.__essSearchTerms; window.__essSearchTerms = undefined;
    var __si = document.getElementById("searchInput"); if (__si) __si.value = __st;
    var __sp = document.getElementById("searchPanel"); if (__sp) __sp.classList.add("open");
    runSearch();
  }
  var heroVid = document.getElementById("heroVideo");
  if (heroVid){ heroVid.muted = true; heroVid.defaultMuted = true; var vp = heroVid.play(); if (vp && vp.catch) vp.catch(function(){}); }
  var heroBtn = document.getElementById("heroShopBtn");
  if (heroBtn){
    heroBtn.addEventListener("click", function(){
      var t = document.getElementById("collectionsStart");
      if (t){
        var y = t.getBoundingClientRect().top + window.scrollY - 96;
        smoothScrollTo(Math.max(0, y), 860);
      }
    });
  }

  if (parts[0]==="shop" || parts[0]==="collection"){
    bindShopToolbar(parts[0]==="collection" ? parts[1] : null);
    var resetBtn = document.getElementById("resetFilterBtn");
    if (resetBtn) resetBtn.addEventListener("click", function(){ shopState.cat="all"; shopState.accord="all"; shopState.sort="featured"; render(); });
  }

  if (parts[0]==="product"){
    var prod = byId(parts[1]), qty = 1, out = document.getElementById("qOut");
    var selSize = (prod.variants && prod.variants[0]) ? prod.variants[0].id : "100ml";
    function essSelVariant(){ return variantById(prod, selSize); }
    function essWaRefresh(){ var w = document.getElementById("pdWaBtn"); if (w) w.href = waProductLink(prod, selSize, qty); }
    document.getElementById("qInc").addEventListener("click", function(){ qty=Math.min(99,qty+1); out.textContent=qty; essWaRefresh(); });
    document.getElementById("qDec").addEventListener("click", function(){ qty=Math.max(1,qty-1); out.textContent=qty; essWaRefresh(); });
    essWaRefresh();
    app.querySelectorAll("[data-size-opt]").forEach(function(b){
      b.addEventListener("click", function(){
        selSize = b.getAttribute("data-size-opt");
        app.querySelectorAll("[data-size-opt]").forEach(function(x){ x.classList.remove("active"); });
        b.classList.add("active");
        var __sv = essSelVariant();
        document.getElementById("pdPriceDisplay").innerHTML = formatINR(__sv ? Math.round(__sv.price) : prod.price) + ' <span style="font-size:13px;color:var(--muted);font-family:var(--sans);font-weight:400">Inclusive of all taxes</span>';
        essWaRefresh();
      });
    });
    document.getElementById("pdAdd").addEventListener("click", function(){ addToCart(parts[1], qty, selSize); openCart(); });
    document.getElementById("pdBuyNow").addEventListener("click", function(){ var __v = essSelVariant(); if (__v){ addVariantToCart(__v.id, qty, prod, __v.title, true); setTimeout(function(){ location.href = checkoutUrl(); }, 450); } });
    var pdWish = document.getElementById("pdWishBtn");
    if (pdWish){
      pdWish.addEventListener("click", function(){
        pdWish.textContent = isWished(parts[1]) ? "♥ Saved in Wishlist" : "♡ Save to Wishlist";
      });
    }
    app.querySelectorAll("[data-thumb]").forEach(function(b){
      b.addEventListener("click", function(){
        document.getElementById("pdMain").src = b.getAttribute("data-thumb");
        app.querySelectorAll("[data-thumb]").forEach(function(x){ x.classList.remove("active"); });
        b.classList.add("active");
      });
    });
    app.querySelectorAll(".acc-head").forEach(function(h){
      h.addEventListener("click", function(){ h.parentElement.classList.toggle("open"); });
    });
    var revForm = document.getElementById("reviewForm");
    if (revForm){
      revForm.addEventListener("submit", function(e){
        e.preventDefault();
        var stored = loadJSON("essenceora_reviews_v1", {});
        if (!stored[parts[1]]) stored[parts[1]] = [];
        stored[parts[1]].unshift({
          name: document.getElementById("revName").value.trim(),
          rating: Number(document.getElementById("revRating").value) || 5,
          date: "Just now",
          text: document.getElementById("revText").value.trim()
        });
        saveJSON("essenceora_reviews_v1", stored);
        showToast("Thank you — your review is published");
        render();
      });
    }
  }

  if (parts[0]==="wishlist"){
    var moveAll = document.getElementById("wishMoveAllBtn");
    if (moveAll){
      moveAll.addEventListener("click", function(){
        wishlist.slice().forEach(function(id){ addToCart(id, 1, "100ml"); });
        openCart();
      });
    }
  }

  if (parts[0]==="contact"){
    var ctForm = document.getElementById("contactForm");
    if (ctForm){
      ctForm.addEventListener("submit", function(e){
        e.preventDefault();
        var fd = new FormData();
        fd.append("form_type", "contact"); fd.append("utf8", "\u2713");
        fd.append("contact[name]", (document.getElementById("ctName") || {}).value || "");
        fd.append("contact[email]", (document.getElementById("ctEmail") || {}).value || "");
        fd.append("contact[body]", "[" + ((document.getElementById("ctSubject") || {}).value || "") + "] " + ((document.getElementById("ctMsg") || {}).value || ""));
        fetch("/contact", { method: "POST", body: fd })
          .then(function(){ ctForm.reset(); showToast("Message received — our Mumbai studio will reply shortly"); })
          .catch(function(){ showToast("Please try again"); });
      });
    }
  }
}
window.addEventListener("hashchange", render);

/* ============ GLOBAL WIRING ============ */
document.getElementById("bagBtn").addEventListener("click", openCart);
document.getElementById("drawerClose").addEventListener("click", closeCart);
document.getElementById("overlay").addEventListener("click", closeCart);
document.getElementById("continueBtn").addEventListener("click", closeCart);
document.getElementById("burgerBtn").addEventListener("click", function(){ document.getElementById("mobileMenu").classList.add("open"); });
document.getElementById("mmClose").addEventListener("click", function(){ document.getElementById("mobileMenu").classList.remove("open"); });
document.querySelectorAll("#mobileMenu nav a").forEach(function(a){ a.addEventListener("click", function(){ document.getElementById("mobileMenu").classList.remove("open"); }); });

document.getElementById("checkoutBtn").addEventListener("click", function(){
  closeCart();
  location.href = checkoutUrl();
});
document.getElementById("drawerPromoBtn").addEventListener("click", function(){
  var res = applyPromoCode(document.getElementById("drawerPromoInput").value);
  showToast(res.msg);
});
var nlForm = document.getElementById("newsletterForm");
if (nlForm) nlForm.addEventListener("submit", function(e){
  e.preventDefault();
  var email = document.getElementById("newsletterEmail").value.trim();
  if (!email) return;
  var fd = new FormData();
  fd.append("form_type", "customer"); fd.append("utf8", "\u2713");
  fd.append("contact[email]", email);
  fetch("/contact", { method: "POST", body: fd })
    .then(function(){ nlForm.reset(); showToast("Subscribed — welcome to ESSENCEORA (Code: FIRST10)"); })
    .catch(function(){ showToast("Please try again"); });
});

/* Search */
var searchPanel = document.getElementById("searchPanel");
var searchInput = document.getElementById("searchInput");
function runSearch(){
  var q = searchInput.value.trim();
  var box = document.getElementById("searchResults");
  if (!q){ box.innerHTML = '<p style="color:var(--muted)">Type a fragrance name, note, or mood — try &ldquo;Blush Theory&rdquo;, &ldquo;Afterdark&rdquo;, &ldquo;Oudora&rdquo; or &ldquo;Citrus Rush&rdquo;.</p>'; return; }
  box.innerHTML = '<p style="color:var(--muted)">Searching the collection…</p>';
  fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide')
    .then(function(r){ return r.json(); })
    .then(function(d){
      var prods = (d.resources && d.resources.results && d.resources.results.products) || [];
      if (!prods.length){ box.innerHTML = '<p style="color:var(--muted)">No fragrances match &ldquo;' + q.replace(/</g, '&lt;') + '&rdquo;. Browse the full collection instead.</p>'; return; }
      var hits = prods.map(function(sp){
        var p = byId(sp.handle);
        return p || { id: sp.handle, name: (sp.title || '').toUpperCase(), num: '', profile: '', shortDesc: '', img: sp.image, alt: sp.image, badge: '', cat: 'unisex', price: Math.round((sp.price || 0) / 100), rating: 0, reviewsCount: 0, variants: [] };
      });
      box.innerHTML = gridHTML(hits);
      bindQuickAdd(box);
      box.querySelectorAll("a").forEach(function(a){ a.addEventListener("click", function(){ searchPanel.classList.remove("open"); }); });
    })
    .catch(function(){ box.innerHTML = '<p style="color:var(--muted)">Search is unavailable right now — please try again.</p>'; });
}

document.getElementById("searchBtn").addEventListener("click", function(){ searchPanel.classList.add("open"); runSearch(); setTimeout(function(){ searchInput.focus(); }, 50); });
document.getElementById("searchClose").addEventListener("click", function(){ searchPanel.classList.remove("open"); });
searchInput.addEventListener("input", runSearch);
document.addEventListener("keydown", function(e){ if (e.key==="Escape"){ closeCart(); searchPanel.classList.remove("open"); document.getElementById("mobileMenu").classList.remove("open"); } });

/* ============ SMOOTH SCROLL ENGINE, PARALLAX & REVEAL ============ */
var prefersReducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
var smoothState = { current: window.scrollY || 0, target: window.scrollY || 0, rafId: null, tweenId: null };

function getMaxScrollY(){
  return Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
}

function updateScrollVisuals(){
  var y = window.scrollY || window.pageYOffset || 0;
  siteTop.classList.toggle("scrolled", y > 24);
  var max = getMaxScrollY();
  var progBar = document.getElementById("scrollProgressBar");
  if (progBar){
    var ratio = max > 0 ? Math.min(1, Math.max(0, y / max)) : 0;
    progBar.style.transform = "scaleX(" + ratio.toFixed(4) + ")";
  }
  var backBtn = document.getElementById("backToTop");
  if (backBtn) backBtn.classList.toggle("visible", y > 420);

  if (!prefersReducedMotion){
    var hv = document.getElementById("heroVideo");
    if (hv && y < window.innerHeight * 1.2){
      hv.style.transform = "translate3d(0," + (y * 0.18).toFixed(1) + "px,0) scale(1.04)";
    }
  }
}
window.addEventListener("scroll", function(){
  if (!smoothState.rafId && !smoothState.tweenId){
    smoothState.current = window.scrollY || 0;
    smoothState.target = smoothState.current;
  }
  updateScrollVisuals();
}, { passive:true });

function runSmoothLerp(){
  var diff = smoothState.target - smoothState.current;
  if (Math.abs(diff) > 0.45){
    smoothState.current += diff * 0.11;
    window.scrollTo(0, Math.round(smoothState.current * 10) / 10);
    smoothState.rafId = requestAnimationFrame(runSmoothLerp);
  } else {
    smoothState.current = smoothState.target;
    window.scrollTo(0, Math.round(smoothState.target));
    smoothState.rafId = null;
  }
}

function canScrollInner(el, deltaY){
  while (el && el !== document.body && el !== document.documentElement){
    if (el.classList && (el.classList.contains("drawer-items") || el.classList.contains("search-panel") || el.tagName === "TEXTAREA" || el.tagName === "SELECT")){
      var canUp = el.scrollTop > 0;
      var canDown = el.scrollTop + el.clientHeight < el.scrollHeight - 1;
      if ((deltaY < 0 && canUp) || (deltaY > 0 && canDown)) return true;
    }
    el = el.parentElement;
  }
  return false;
}

/* Native scrolling is used everywhere (the custom wheel hijack was removed:
   it called preventDefault() on wheel events and could leave the page
   unscrollable if its internal state desynced). Anchor/button smoothness
   comes from CSS scroll-behavior:smooth on html and smoothScrollTo(). */

function smoothScrollTo(targetY, duration){
  var dest = Math.max(0, Math.min(getMaxScrollY(), targetY));
  if (prefersReducedMotion){
    window.scrollTo(0, dest);
    smoothState.current = dest; smoothState.target = dest;
    return;
  }
  if (smoothState.rafId){ cancelAnimationFrame(smoothState.rafId); smoothState.rafId = null; }
  if (smoothState.tweenId){ cancelAnimationFrame(smoothState.tweenId); smoothState.tweenId = null; }
  var startY = window.scrollY || 0;
  var change = dest - startY;
  if (Math.abs(change) < 2){ window.scrollTo(0, dest); smoothState.current = dest; smoothState.target = dest; return; }
  var startTime = performance.now();
  var dur = duration || 760;
  function step(now){
    var t = Math.min(1, (now - startTime) / dur);
    var ease = 1 - Math.pow(1 - t, 3.6);
    var cur = startY + change * ease;
    window.scrollTo(0, cur);
    smoothState.current = cur;
    smoothState.target = cur;
    if (t < 1){
      smoothState.tweenId = requestAnimationFrame(step);
    } else {
      smoothState.tweenId = null;
      smoothState.current = dest;
      smoothState.target = dest;
    }
  }
  smoothState.tweenId = requestAnimationFrame(step);
}

function smoothScrollResetTop(){
  if (smoothState.rafId){ cancelAnimationFrame(smoothState.rafId); smoothState.rafId = null; }
  if (smoothState.tweenId){ cancelAnimationFrame(smoothState.tweenId); smoothState.tweenId = null; }
  smoothState.current = 0;
  smoothState.target = 0;
  window.scrollTo(0, 0);
  updateScrollVisuals();
}

var revealObserver = null;
function initScrollReveal(scope){
  if (prefersReducedMotion) return;
  if (revealObserver) revealObserver.disconnect();
  var targets = scope.querySelectorAll(".carousel-head, .card, .coll-banner, .page-banner .pb-copy, .community, .co-panel, .order-card, .contact-card, .product-wrap > div, .content > *");
  if (!("IntersectionObserver" in window)){
    targets.forEach(function(el){ el.classList.add("in-view"); });
    return;
  }
  revealObserver = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if (entry.isIntersecting){
        entry.target.classList.add("in-view");
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: "0px 0px -32px 0px" });

  targets.forEach(function(el, idx){
    el.classList.add("reveal-item");
    if (el.classList.contains("card")){
      el.style.transitionDelay = ((idx % 4) * 55) + "ms";
    }
    revealObserver.observe(el);
  });
}

(function(){
  var btb = document.getElementById("backToTop");
  if (btb) btb.addEventListener("click", function(){ smoothScrollTo(0, 820); });
  try {
    updateWishUI();
    render();
    refreshCart();
  } catch (e) {
    var appEl = document.getElementById("app");
    var msg = "Storefront error: " + (e && e.message ? e.message : e);
    if (appEl && !appEl.innerHTML) appEl.innerHTML = '<div style="padding:120px 24px;text-align:center;font-family:sans-serif"><h2>ESSENCEORA</h2><p>'+msg+'</p></div>';
    throw e;
  }
})();
